import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EpdkErrorDialogModule } from '../../ui/error-dialog/error-dialog.module';
import { EpdkErrorSnackBarModule } from '../../ui/error-snack-bar/error-snack-bar.module';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatDialogModule,
    MatSnackBarModule,

    EpdkErrorDialogModule,
    EpdkErrorSnackBarModule
  ]
})
export class ErrorServiceModule { }
